import { useEffect, useState } from "react";
import imageCompression from "browser-image-compression";

function useImageCompression(image: File | undefined) {
  const [compressedImage, setCompressedImage] = useState<File>();

  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (image && !compressedImage) {
      imageCompression(image, {
        preserveExif: true,
        fileType: isSafari ? "image/jpeg" : "image/webp",
        initialQuality: 0.75,
        maxWidthOrHeight: 1920,
      }).then((i) => {
        const f = new File([i], `${crypto.randomUUID()}/observation.webp`, {
          type: "image/webp",
          lastModified: i.lastModified || Date.now(),
        });
        setCompressedImage(f);
      });
    }
  }, [image, compressedImage]);

  return { compressedImage };
}

export default useImageCompression;
